<template>
    <div :class="{ expend: expend, full: selected !== null }" class="index-nav">
        <div class="navigation">
            <div v-for="(item, index) in navList" :key="index"
                 :class="{ selected: isSelected(item, index) }"
                 class="nav-item"
                 @click="selectIndex(item, index)">
                <div class="nav-title">
                    <div style="display: flex;">
                        <div class="nav-icon">
                            <span :style="navIcon(item.code)" class="nav-icon-line"></span>
                            <span :style="navIcon(item.code + '-b')" class="nav-icon-block"></span>
                        </div>
                        <div>{{ $d(item.name) }}</div>
                    </div>
                    <div class="selected-icon"></div>
                </div>
            </div>
        </div>
        <div v-if="selected !== null" :class="{ expend }" class="sub-nav-panel">
            <div class="mask" @click="close"></div>
            <div class="sub-nav">
                <div class="search-nav">
                    <el-input v-model="searchInput" :placeholder="$d('输入以搜索')"
                              class="input-with-select"
                              size="small">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                    <div class="close" @click="close"></div>
                </div>
                <div class="navs-content">
                    <div v-if="subNavList.length" class="sub-nav-content">
                        <div v-for="(col, n) in chunkList(subNavList)" :key="n" class="sub-nav-col">
                            <div v-for="(item, index) in col" :key="index" class="sub-nav-group">
                                <div class="sub-nav-title">
                                    {{ $d(item.name) }}
                                </div>
                                <div v-if="item.children && item.children.length" class="nav-list">
                                    <div v-for="(nav, i) in item.children" :key="i" class="sub-nav-item"
                                         @click="selectItem(nav)">
                                        <span v-html="$d(nav.name)"></span>
                                        <span :class="nav.isFavorite === 'Y' ? 'el-icon-star-on' : 'el-icon-star-off'"
                                              class="star"
                                              @click.stop="toggleFavorite(nav)"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="navs-content-empty">
                        <div class="empty-icon"></div>
                        {{ $d('暂无内容') }}
                    </div>
                    <div class="favorite-nav">
                        <div>{{ $d('菜单收藏') }}</div>
                        <div v-for="(nav, index) in favoriteNav" :key="index" class="sub-nav-item"
                             @click="selectItem(nav)">
                            {{ $d(nav.name) }}
                            <span :class="nav.isFavorite === 'Y' ? 'el-icon-star-on' : 'el-icon-star-off'" class="star"
                                  @click.stop="toggleFavorite(nav)"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'indexNav',
    props: {
        navList: Array,
        expend: Boolean
    },
    computed: {
        favoriteNav () {
            let list = []
            for (let app of this.navList) {
                for (let module of app.children || []) {
                    for (let nav of module.children || []) {
                        if (nav.isFavorite === 'Y') {
                            list.push(nav)
                        }
                    }
                }
            }
            return list
        },
        subNavList () {
            const items = this.navList[this.selected].children || []

            if (this.searchInput) {
                const searchItems = []
                const reg = new RegExp(this.searchInput, 'g')
                const hl = `<span style="background: yellow; color: red">${this.searchInput}</span>`

                for (const item of items) {
                    const hits = []
                    for (const child of item.children) {
                        if (child.name.includes(this.searchInput)) {
                            const highlightedChild = { ...child }
                            highlightedChild.name = child.name.replace(reg, hl)
                            hits.push(highlightedChild)
                        }
                    }
                    if (hits.length) {
                        searchItems.push({
                            ...item,
                            children: hits
                        })
                    }
                }
                return searchItems
            }
            return items
        }
    },
    methods: {
        async toggleFavorite (item) {
            let url = '/etao-system/user-menu/submit'
            if (item.isFavorite === 'Y') {
                url = '/etao-system/user-menu/remove-user-menu'
            }
            await this.etao.requests.post({
                url: url,
                data: {
                    menuId: item.id
                },
                successMessage: false,
                success: res => {
                    if (res.code === 200) {
                        const originalItem = this.findOriginalItem(item.id)
                        if (originalItem) {
                            originalItem.isFavorite = originalItem.isFavorite === 'Y' ? 'N' : 'Y'
                        }
                    }
                }
            })
        },
        findOriginalItem (id) {
            for (const app of this.navList) {
                for (const module of app.children || []) {
                    for (const nav of module.children || []) {
                        if (nav.id === id) {
                            return nav
                        }
                    }
                }
            }
            return null
        },
        navIcon (file) {
            try {
                return {
                    backgroundImage: `url(${require(`@/assets/icon/nav/items/${file}.png`)})`
                }
            } catch (e) {

            }
        },
        isSelected (item, index) {
            return this.selected === index
        },
        chunkList (data) {
            data = data || []

            let result = [
                [], [], [], []
            ]
            let index = 0
            let curr = 0

            while (curr < data.length) {
                result[index++].push(data[curr++])
                if (index > 3) {
                    index = 0
                }
            }

            return result
        },
        selectIndex (item, index) {
            if (this.selected === index) {
                this.close()
                return
            }
            if (item && item.code === 'desk') {
                this.$emit('selected', JSON.parse(JSON.stringify(item)))
                this.close()
                return
            }
            this.selected = index
        },
        selectItem (item) {
            if (item.isOpen) {
                window.open(item.path)
            } else {
                this.$emit('selected', JSON.parse(JSON.stringify(item)))
            }
            this.close()
        },
        close () {
            this.selected = null
            this.searchInput = ''
        }
    },
    data () {
        return {
            selected: null,
            searchInput: ''
        }
    },
    mounted () {
        window.selectIndex = index => {
            this.selected = index
        }

        this.chunkList()
    }
}
</script>

<style scoped src="./css/index-nav.css"></style>



// WEBPACK FOOTER //
// src/components/index/indexNav.vue